<template>
  <div class="flex flex-row flex-wrap gap-1">
    <div
      v-if="archived"
      class="rounded-small bg-surface-container-highest text-on-surface-variant flex items-center gap-1.5 py-1 pr-2 pl-1"
    >
      <BaseIcon size="20">archive</BaseIcon>
      <span class="text-label-large">
        {{ t('objective.archived') }}
      </span>
    </div>
    <div class="rounded-small flex items-center gap-1.5 py-1 pr-2 pl-1" :class="chipClasses">
      <BaseIcon size="20">{{ icon }}</BaseIcon>
      <span class="text-label-large">
        {{ label }}
      </span>
    </div>
    <div
      v-if="staleMonths != null && staleMonths >= 3"
      class="rounded-small bg-tertiary-container text-on-tertiary-container flex items-center gap-1.5 py-1 pr-2 pl-1"
    >
      <BaseIcon size="20">warning</BaseIcon>
      <span class="text-label-large">
        {{ t('objective.staleOpen', { count: staleMonths }) }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import BaseIcon from '../base/icon/BaseIcon.vue'

  interface Props {
    achieved: boolean
    archived?: boolean
    /** Whole months the objective has been open; shows warning from 3+. */
    staleMonths?: number
  }

  const props = defineProps<Props>()
  const { t } = useI18n()

  const chipClasses = computed(() => {
    if (props.achieved) {
      return 'bg-marsmenschli-90 text-marsmenschli-30'
    }
    return 'bg-primary-container text-on-primary-container'
  })

  const icon = computed(() => {
    if (props.achieved) return 'check_circle'
    return 'target'
  })

  const label = computed(() => {
    if (props.achieved) return t('objective.achieved')
    return t('objective.running')
  })
</script>
